import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="py-12 px-4 pt-[15px] pb-[15px]" data-id="element-279">
      <div className="max-w-6xl mx-auto" data-id="element-280">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-281">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 flex flex-col" data-id="element-282">
              <div className="flex items-center space-x-3 mb-3" data-id="element-283">
                <div className="w-10 h-10 rounded-full bg-brand/20 text-brand flex items-center justify-center font-bold text-lg" data-id="element-284">
                  {t.initials}
                </div>
                <div data-id="element-285">
                  <div className="font-bold text-white text-sm" data-id="element-286">{t.name}</div>
                  <div className="text-xs text-gray-500" data-id="element-287">{t.location}</div>
                </div>
              </div>
              <div className="flex space-x-1 mb-3" data-id="element-288">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 fill-brand text-brand" data-id="element-289" />)}
              </div>
              <p className="text-gray-300 italic flex-grow text-sm" data-id="element-290">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}